import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

const SmartEndpointFormContext = createContext({})

export const useSmartEndpointForm = () => useContext(SmartEndpointFormContext)

function SmartEndpointFormProvider ({ children }) {
  const [code, setCode] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [description, setDescription] = useState('')
  const [source, setSource] = useState('')

  const hasSource = source.trim().length > 0

  const resetForm = useCallback(() => {
    setCode('')
    setDisplayName('')
    setDescription('')
    setSource('')
  }, [])

  const value = useMemo(() => ({
    code,
    setCode,
    displayName,
    setDisplayName,
    description,
    setDescription,
    source,
    setSource,
    hasSource,
    resetForm
  }), [code, displayName, description, source, hasSource, resetForm])

  return (
    <SmartEndpointFormContext.Provider value={value}>
      {children}
    </SmartEndpointFormContext.Provider>
  )
}

SmartEndpointFormProvider.propTypes = {
  children: PropTypes.node
}

export default SmartEndpointFormProvider
